let activeAssistantPythonExecution = null;
let assistantPythonExecutionQueue = Promise.resolve();
export function setActiveAssistantPythonExecution(context) {
    activeAssistantPythonExecution = context;
}
export function getActiveAssistantPythonExecution() {
    return activeAssistantPythonExecution;
}
/** Run one assistant-owned Python execution without allowing lifecycle overlap. */
export function runAssistantPythonExecution(context, run) {
    const execution = assistantPythonExecutionQueue.then(async () => {
        if (activeAssistantPythonExecution) {
            throw new Error('An assistant Python execution is already active.');
        }
        activeAssistantPythonExecution = {
            ...context,
            commitState: 'none',
            settled: Promise.resolve()
        };
        try {
            return await run();
        }
        finally {
            activeAssistantPythonExecution = null;
        }
    });
    assistantPythonExecutionQueue = execution.then(() => undefined, () => undefined);
    return execution;
}
/** Record the exact committed-packet completion owned by the active execution. */
export function setActiveAssistantPythonExecutionCommit(state, settled) {
    if (!activeAssistantPythonExecution) {
        return;
    }
    activeAssistantPythonExecution.commitState = state;
    activeAssistantPythonExecution.settled = settled;
}
/** Wait for the active execution's own committed Yjs refresh, if any. */
export function awaitActiveAssistantPythonExecutionSettled() {
    return activeAssistantPythonExecution?.settled ?? Promise.resolve();
}
export function isAssistantPythonExecutionActive() {
    return activeAssistantPythonExecution !== null;
}
export function assertAssistantFontEditAllowed() {
    if (activeAssistantPythonExecution?.allowFontEdits === false) {
        throw new Error('Assistant font editing is disabled for this prompt. You may inspect font data or change editor UI state, but you cannot modify the font.');
    }
}
